import React from 'react'

function Footer() {
  return (
    <footer>
        <div>
            <h1>Landing Page</h1>
            <p>@all rights reserved Siddharth Bisht 2022</p>
        </div>
        <div>
            <h5>Connect With Us</h5>
            <div>
                <a href="https://github.com/OfficialSiddharthBisht" target={'blank'}>GitHub</a>
                <a href="https://siddharthbisht.netlify.app/" target={'blank'}>Website</a>
                <a href="https://www.linkedin.com/in/siddharth-bisht-57084b198/" target={'blank'}>LinkedIn</a>
            </div>
        </div>
    </footer>
  )
}

export default Footer